import request from '@/utils/httpRequest'

// 青藤
// 分页查询回收单列表
export function getRecycleOrderList (params) {
  return request({
    url: `/recycleOrder/listPage`,
    method: 'get',
    params
  })
}

// 查看回收单详情
export function getRecycleOrderDetail (params) {
  return request({
    url: `/recycleOrder/detail`,
    method: 'get',
    params
  })
}
// 查询回收类型列表
export function getRecycleOrderTypeList (params) {
  return request({
    url: `/recycleOrder/typeList`,
    method: 'get',
    params
  })
}

// 审批
export function approve (data) {
  return request({
    url: `/recycleOrder/approve`,
    method: 'post',
    data,
    type: 'form'
  })
}
// 回单
export function pointOrder (data) {
  return request({
    url: `/recycleOrder/point`,
    method: 'post',
    data,
    type: 'file'
  })
}
